import React from 'react';
import { Constrain } from '@moda/om';
import { getGraphQLErrors } from '../../lib/error';
import './ErrorFallback.scss';

export interface Props {
  error: Error;
  componentStack: string;
}

export const ErrorFallback: React.FC<Props> = ({ componentStack, error }) => {
  const errorStack = (error.stack || componentStack)
    .trim()
    .split('\n')
    .map(line => line.trim())
    .join('\n');

  const graphQLErrors = getGraphQLErrors(error);
  const stackTrace = [errorStack, graphQLErrors && JSON.stringify(graphQLErrors, null, 2)]
    .filter(Boolean)
    .join('\n\n');

  return (
    <div className="ErrorFallback">
      <Constrain>
        <h1 className="ErrorFallback__header">Something went wrong</h1>
        {error.message && <h2 className="ErrorFallback__message">{error.message}</h2>}
        <pre className="ErrorFallback__stack">{stackTrace}</pre>
      </Constrain>
    </div>
  );
};
